import React, { Component } from "react";

import { Grid, Row, Col, } from "react-bootstrap";
import {StripeProvider} from 'react-stripe-elements';
import {Elements} from 'react-stripe-elements';

import StripeForm from './StripeForm'

import '../content/content.css';

class StripeDashboard extends Component {

	constructor() {
		super();
		this.configureStripeKey();		
	}

    configureStripeKey() {
    	if (process.env.NODE_ENV === "production") {
    		this.stripeKey = 'pk_live_T3Zzell1TkOibDhuiYDkt2ia';
    	} else {
    		this.stripeKey = 'pk_test_rN93P9gUHguXIvDM1HqA1Qwv';
    	}
    }

	render() {
		return (
			<StripeProvider apiKey={this.stripeKey}>
				<Elements>
					<Grid>				
						<Row>
							<Col sm={12} className="text-center">
								<StripeForm/>
							</Col>
						</Row>
					</Grid>
				</Elements>
			</StripeProvider>
		)
	}
}

export default StripeDashboard;


// WEBPACK FOOTER //
// ./src/stripe/StripeDashboard.js